import orderBy from 'lodash/orderBy';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import {
    FEATURED_MATCH_COUNT,
    UPCOMING_MATCH_COUNT,
} from '@/components/tournamentCenter/config';
import { _usePromotionZone } from '@/composable/usePromotionZone';
import { useTournamentEvents } from '@/core/oddsApi/composable/useTournamentEvents';
import {
    getEventPresetFilterInputType,
    getOddsCategory,
} from '@/core/oddsApi/helpers';
import { MarketPage, SiteStyle, SportType } from '@/interface/enum';
import { useToggleStore } from '@/store/toggleStore';

export function useTournamentCenterOverviewMatches() {
    const { tournamentCenterLeagueNames, tournamentCenterMainLeagueIds } = storeToRefs(useToggleStore(SiteStyle.Asia));
    const { currentPromotionZoneConfig } = _usePromotionZone();
    const { events, loaded, loading, eventsError, refetch } = useTournamentEvents(
        {
            sportType: currentPromotionZoneConfig.value?.defaultSport ?? SportType.Soccer,
            presetFilter: getEventPresetFilterInputType(MarketPage.All),
            oddsCategory: getOddsCategory(MarketPage.All),
            leagueNames: tournamentCenterLeagueNames.value,
        },
    );

    const orderedEvents = computed(() => orderBy(
        events.value,
        [x => x.absKickOffTime.getTime(), x => x.eventCode],
        ['asc', 'asc'],
    ));

    const featuredMatches = computed(() => orderedEvents.value
        .filter(event => tournamentCenterMainLeagueIds.value.includes(event.league.id))
        .slice(0, FEATURED_MATCH_COUNT));

    const upcomingMatches = computed(() => {
        const featuredEventIds = new Set(featuredMatches.value.map(x => x.id));
        const filteredEvents = orderedEvents.value.filter(
            event => !featuredEventIds.has(event.id)
        && tournamentCenterMainLeagueIds.value.includes(event.league.id)
        && !event.isLive,
        );
        return filteredEvents.slice(0, UPCOMING_MATCH_COUNT);
    });

    return {
        loaded,
        loading,
        eventsError,
        refetch,
        orderedEvents,
        featuredMatches,
        upcomingMatches,
    };
}
